export function getDesignationPermissionsByModule(
  designationPermissions,
  moduleName
) {
  const modulePermission = designationPermissions?.find(
    (perm) => perm.module === moduleName
  );

  return {
    permissionId: modulePermission?.id,
    hasReadAccess: modulePermission?.isRead ?? false,
    hasWriteAccess: modulePermission?.isWrite ?? false,
    hasUpdateAccess: modulePermission?.isUpdate ?? false,
    hasDeleteAccess: modulePermission?.isDelete ?? false,
  };
}
